// removed by extract-text-webpack-plugin
module.exports = {"social-media":"index__social-media___Xpwti","socialMedia":"index__social-media___Xpwti"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/SocialMedia/index.css
// module id = 992
// module chunks = 37